import React, { useState, useEffect } from 'react';
import { AdminLayout } from '../components/AdminLayout';
import { Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function AdminCostingListPage() {
  const [costings, setCostings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchCostings();
  }, [filter]);

  const fetchCostings = async () => {
    try {
      let url = `${API_URL}/api/admin/costings`;
      if (filter !== 'all') {
        url += `?status=${filter}`;
      }
      
      const response = await fetch(url, { credentials: 'include' });
      const data = await response.json();
      setCostings(data);
    } catch (error) {
      console.error('Failed to fetch costings:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout>
      <div className="p-8">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-serif text-white mb-2">Costings</h1>
            <p className="text-gray-400">Manage travel costings and pricing</p>
          </div>
          <Link
            to="/admin/costing/new"
            className="px-6 py-3 bg-[#C4A962] hover:bg-[#B89952] text-[#0A0F1E] font-semibold rounded-lg transition-colors"
          >
            + New Costing
          </Link>
        </div>

        {/* Filters */}
        <div className="flex gap-2 mb-6">
          {['all', 'Draft', 'Completed', 'Archived'].map((status) => (
            <button
              key={status}
              onClick={() => setFilter(status)}
              className={`px-4 py-2 rounded-lg text-sm transition-colors ${
                filter === status
                  ? 'bg-[#C4A962] text-[#0A0F1E]'
                  : 'bg-[#0F1629] text-gray-300 hover:bg-[#1E293B]'
              }`}
            >
              {status === 'all' ? 'All' : status}
            </button>
          ))}
        </div>

        {/* Costings Table */}
        <div className="bg-[#0F1629] border border-[#1E293B] rounded-lg overflow-hidden">
          {loading ? (
            <div className="p-8 text-center text-gray-400">Loading...</div>
          ) : costings.length === 0 ? (
            <div className="p-8 text-center text-gray-400">No costings found</div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-[#0A0F1E] border-b border-[#1E293B]">
                  <tr>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Reference</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Client</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Destination</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Travel Date</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Pax</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">IDR Cost</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">IDR Selling</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Quotation</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Status</th>
                    <th className="text-left p-4 text-sm font-medium text-gray-400">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {costings.map((costing) => (
                    <tr key={costing.id} className="border-b border-[#1E293B] hover:bg-[#0A0F1E] transition-colors">
                      <td className="p-4 text-sm text-white font-medium">{costing.reference}</td>
                      <td className="p-4 text-sm text-gray-300">{costing.client_name}</td>
                      <td className="p-4 text-sm text-gray-300">{costing.destination}</td>
                      <td className="p-4 text-sm text-gray-300">{costing.travel_start_date}</td>
                      <td className="p-4 text-sm text-gray-300">{costing.pax}</td>
                      <td className="p-4 text-sm text-gray-300">
                        IDR {(costing.total_idr_cost || 0).toLocaleString()}
                      </td>
                      <td className="p-4 text-sm text-gray-300">
                        IDR {(costing.idr_selling_price || 0).toLocaleString()}
                      </td>
                      <td className="p-4 text-sm text-gray-300">
                        {costing.quotation_currency || 'IDR'} {(costing.quotation_amount || 0).toLocaleString()}
                      </td>
                      <td className="p-4">
                        <span className={`text-xs px-2 py-1 rounded ${
                          costing.status === 'Draft' ? 'bg-yellow-500/10 text-yellow-400' :
                          costing.status === 'Completed' ? 'bg-green-500/10 text-green-400' :
                          'bg-gray-500/10 text-gray-400'
                        }`}>
                          {costing.status}
                        </span>
                      </td>
                      <td className="p-4">
                        <Link
                          to={`/admin/costing/${costing.id}`}
                          className="text-[#C4A962] hover:text-[#B89952] text-sm transition-colors"
                        >
                          View →
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
